
export interface ConfigurationState {
    visualizerApiUrl : URL 
    bimVaultApiUrl : URL | undefined     
    threeDeeApiUrl : URL  | undefined
    coreApiUrl : URL | undefined
    preferredLanguage : string | undefined
    configurationLoaded : boolean
}; 

export enum ConfigurationStateActionEnum {
    SET_BIMVAULT_URL = "SET_BIMVAULT_URL",
    SET_THREE_DEE_URL = "SET_THREE_DEE_URL",
    SET_CORE_API_URL = "SET_CORE_API_URL",
    SET_CONFIGURATION = "SET_CONFIGURATION"
};

export interface SetBimVaultUrl{
    type: ConfigurationStateActionEnum.SET_BIMVAULT_URL,
    data: URL | undefined
  }

  export interface SetThreeDeeUrl{
    type: ConfigurationStateActionEnum.SET_THREE_DEE_URL,
    data: URL | undefined
  }

  export interface SetCoreApiUrl{
    type: ConfigurationStateActionEnum.SET_CORE_API_URL,
    data: URL | undefined
  }

  export interface SetConfiguration{
    type: ConfigurationStateActionEnum.SET_CONFIGURATION
    data: ConfigurationState
  }

export type ConfigurationStateActionType = SetBimVaultUrl | SetThreeDeeUrl | SetCoreApiUrl | SetConfiguration; 
